export default "__VITE_ASSET__CAhOj8uw__"